import React from 'react';
import { Box, Divider, TextField, Typography, useTheme, Paper, Button } from '@mui/material';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { verifyOtpSchema } from '../../../helpers/validations/forgotPasswordValidation';
import { controlPanelAdminVerifyOtp, studentVerifyOtp } from '../../../api/login/loginService';
import { ROUTES } from '../../../constants/routes';
import { useSelector } from 'react-redux';

const OtpVerification = ({ formData }) => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const [position, setPosition] = React.useState(50);
  const navigate = useNavigate();
  const currentLocation = useLocation();
  const routeName = currentLocation.pathname;

  const forgotToLoginMap = {
    [ROUTES.ADMINFORGOTPASSWORD]: ROUTES.ADMINSIGNIN,
  };

  const backToLoginPath = forgotToLoginMap[routeName] || ROUTES.STUDENTSIGNIN;
  const customColors = useSelector(state => state.theme.customColors);
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(verifyOtpSchema),
  });

  const onSubmit = async data => {
    try {
      const payload = {
        emailId: formData.email,
        otp: data.otp,
        newPassword: formData.newPassword,
      };

      let response;

      switch (routeName) {
        case '/admin-forgot-password':
          response = await controlPanelAdminVerifyOtp(payload);
          if (response?.success) {
            // toast.success('Password reset successful!');
            //showSnackbar('Password reset successful!', 'success');
            navigate('/login');
          } else {
           // showSnackbar('Invalid OTP.', 'error');
          }
          break;
        default:
          response = await studentVerifyOtp(payload);
          if (response?.success) {
            // toast.success('Password reset successful!');
           // showSnackbar('Password reset successful!', 'success');
            navigate('/student-login');
          } else {
           // showSnackbar('Invalid OTP.', 'error');
          }
          break;
      }
    } catch (err) {
      // toast.error(err.message || 'Invalid OTP or error verifying. Please try again.');
      //showSnackbar(err.message || 'Invalid OTP or error verifying. Please try again.', 'error');
    }
  };

  const onFormError = formErrors => {
    const firstError = Object.values(formErrors)[0];
    if (firstError?.message) {
      // toast.error(firstError.message);
      //showSnackbar(firstError.message, 'error');
    }
  };

  return (
   <Paper sx={{ maxWidth: 400, p: 4, mx: "auto", mt: 10 }}>
      <Typography variant="h5" mb={2}>Login</Typography>
      <form onSubmit={handleSubmit(onSubmit, onFormError)} noValidate>
        <TextField
          fullWidth
          size='small'
          label="Enter OTP"
          variant="filled"
          sx={{ mb: 2 }}
          error={!!errors.otp}
          helperText={errors.otp?.message}
          {...register('otp')}
          className="cp-form-control input-focus"
        />
        <Button variant="contained" type='submit' fullWidth sx={{ mt: 2 }}
          disabled={isSubmitting}
        // {isSubmitting ? 'Logging in...' : 'Log In'}
        >Submit</Button>

        <Box textAlign="right" mt={1}>
          <Link to={ROUTES.ADMINSIGNIN}>Login?</Link>
        </Box>
      </form>
    </Paper>
  );
};

export default OtpVerification;
